import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PublicReviewPage from "features/public/pages/PublicReviewPage";
import api, { API_BASE_URL } from "api/axiosConfig";
import SEO from "components/SEO";
import { trackAnalyticsEvent } from "api/analyticsApi";

export default function CollectEmbed() {
  const { spaceSlug } = useParams();

  const [space, setSpace] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function loadSpace() {
      if (!spaceSlug) {
        setError("Missing space slug");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError("");

        const res = await api.public_api.get(
          `/api/spaces/slug/${encodeURIComponent(spaceSlug)}`
        );

        if (!cancelled) {
          setSpace(res.data);
          setLoading(false);

          trackAnalyticsEvent({
            eventType: "collect_embed_loaded",
            spaceId: res.data?._id,
            spaceSlug,
            source: "collect_embed",
            metadata: { embed: true },
          });
        }
      } catch (err) {
        console.error(
          "Error loading space for collect embed:",
          err.response?.data || err.message || err
        );

        if (!cancelled) {
          setError(
            err.response?.data?.message ||
              err.response?.data?.error ||
              "Failed to load space"
          );
          setLoading(false);
        }
      }
    }

    loadSpace();

    return () => {
      cancelled = true;
    };
  }, [spaceSlug]);

  useEffect(() => {
    function sendHeight() {
      const height = Math.max(
        document.body.scrollHeight || 0,
        document.documentElement.scrollHeight || 0,
        300
      );

      window.parent.postMessage(
        {
          type: "testimonial-embed:resize",
          height,
          spaceSlug,
        },
        "*"
      );
    }

    sendHeight();

    let observer = null;

    if (typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(sendHeight);
      observer.observe(document.body);
    }

    const intervalId = window.setInterval(sendHeight, 1000);

    return () => {
      if (observer) observer.disconnect();
      window.clearInterval(intervalId);
    };
  }, [spaceSlug, loading, error, space]);

  if (loading) {
    return (
      <div
        style={{
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          padding: 16,
          minHeight: 260,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#6b7280",
        }}
      >
        Loading testimonial form...
      </div>
    );
  }

  if (error || !space) {
    return (
      <div
        style={{
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          padding: 16,
          color: "#dc2626",
          background: "#fff1f2",
          border: "1px solid #fecdd3",
          borderRadius: 12,
          margin: 12,
        }}
      >
        <strong>Unable to load testimonial form.</strong>
        <div style={{ marginTop: 8, fontSize: 13 }}>
          {error || "Space not found"}
        </div>
        <div style={{ marginTop: 8, fontSize: 12, color: "#7f1d1d" }}>
          API: {API_BASE_URL}/api/spaces/slug/{spaceSlug}
        </div>
      </div>
    );
  }

  return (
    <>
    <SEO
  title="Embedded Testimonial Collection Form - TestimonialsHub"
  description="Collect customer testimonials directly from your website using embedded testimonial collection forms with video and text support."
  keywords="embedded testimonial form, collect testimonials, video review embed, customer feedback widget"
  path="/embed/collect"
/>
    <div
  
      style={{
        minHeight: "100vh",
        margin: 0,
        padding: 0,
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        background: "#f3f4f6",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 520,
          marginTop: 24,
          marginBottom: 24,
          paddingLeft: 12,
          paddingRight: 12,
          boxSizing: "border-box",
        }}
      >
        <PublicReviewPage embedMode spaceOverride={space} />
      </div>
    </div>
    </>
  );
}
